import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PinFlowPage } from './pin-flow.page';

const routes: Routes = [
  {
    path: '',
    component: PinFlowPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PinFlowPageRoutingModule {}
